import { BadgePercent, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const PROMO = {
  headline: "Up To $50 Off Your First Haul",
  details: "Save $25 on your first haul quoted at $199–$249, or $50 on your first haul quoted at $250 or more. Hauls under $199 do not qualify.",
  terms: "Discount is based on the quoted price before the discount. One discount per customer, applied to your first haul only.",
};

export const PromoDetails = ({ testid, light = false }) => (
  <>
    <p data-testid={`${testid}-details`} className={`mt-3 max-w-2xl text-sm font-semibold leading-relaxed md:text-base ${light ? "text-ink/85" : "text-white/85"}`}>
      {PROMO.details}
    </p>
    <p data-testid={`${testid}-terms`} className={`mt-2 max-w-2xl text-xs font-semibold leading-relaxed md:text-sm ${light ? "text-ink/70" : "text-warmgray"}`}>
      {PROMO.terms}
    </p>
  </>
);

export const PromoBanner = () => (
  <section id="first-haul-offer" data-testid="promo-banner" className="relative border-y-2 border-gold bg-gold">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 px-5 py-8 md:px-8 md:py-10 lg:flex-row lg:items-center lg:justify-between">
      <Reveal>
        <div className="flex items-start gap-4">
          <span className="flex h-14 w-14 shrink-0 items-center justify-center border-2 border-ink bg-ink">
            <BadgePercent size={28} strokeWidth={1.8} className="text-gold" />
          </span>
          <div>
            <p className="font-body text-xs font-bold uppercase tracking-[0.25em] text-ink/70">Yard Sign Offer · New Customers</p>
            <p data-testid="promo-banner-headline" className="mt-1 font-heading text-3xl uppercase leading-none tracking-wide text-ink md:text-5xl">
              {PROMO.headline}
            </p>
            <PromoDetails testid="promo-banner" light />
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <a
          href="#contact"
          data-testid="promo-banner-button"
          className="btn-brutal-dark flex w-fit shrink-0 items-center gap-3 border-2 border-ink bg-ink px-8 py-4 font-heading text-xl uppercase tracking-wide text-gold shadow-[6px_6px_0_rgba(0,0,0,0.35)]"
        >
          Claim Your First-Haul Savings <ArrowRight size={18} strokeWidth={2.5} />
        </a>
      </Reveal>
    </div>
  </section>
);
